/**
 * Created by nijin on 5/6/17.
 */
import {Component, OnInit, ViewChild, Input, OnChanges} from '@angular/core';
import {ViewKeyComponent} from '../modal/view.key';
import {NotificationBarService} from '../../../core/notify/notification.service';


@Component({
  selector: 'nuc-key-notifier',
  template: `
   <div class="keyNotifier clearfix" [ngClass]="{'show':isActive}">
   		<p id="hideMe" *ngIf="loadingNotifier">The old API key can be used till {{isActive ? (keyOnExpire[0].timeToLive | datex :'DD MMMM YYYY  h:mm:ss A') : ''}}</p>
   		<div *ngIf="keyOnExpire.length && !loadingNotifier">
	   	 	<p id="expire-notification">You have more than 1 active key.</p>
		   	<button class="btn btn-sec" id="notification-dismiss" (click)="isActive = !isActive">Dismiss</button>
		   	<button class="btn btn-prim" id="notification-view" (click)="showKey()">View</button>
   		</div>
   </div>
    <nuc-view-key #viewKey [keys]="keys" (onAccept)="onDeleteKey($event)"></nuc-view-key>
  `,
  styleUrls: ['./notifier.scss']
})
export class NotifierComponent implements OnInit, OnChanges {
  @ViewChild ('viewKey') popup: ViewKeyComponent;

  @Input() keys;
   isActive = false;
   keyOnExpire: any  = [];
   isLoading = false;
   loadingNotifier = true;

  constructor(private  notifier: NotificationBarService) { }

  ngOnInit() {
    this.setNotifierActive();
  }

  ngOnChanges() {
    this.setNotifierActive();
  }

  showKey() {
     this.popup.open();
  }

  setNotifierActive(): void {
    if (this.keys && this.keys.length > 1) {
      this.keyOnExpire = this.keys.filter( item =>  item.timeToLive > -1);
      this.isActive = this.keyOnExpire.length ? true : false;
    }
    this.loadingNotifier = true;
    this.loadNotifier();
  }

  onDeleteKey(event) {
    if (this.keys && this.keys.length > 1) {
      this.keyOnExpire = this.keys.filter( item =>  item.timeToLive > -1);
      this.isActive = this.keyOnExpire.length ? true : false;
    } else {
      this.isActive = false;
    }

  }

  private loadNotifier() {
    setTimeout(() => { this.loadingNotifier = false; }, 3000);
  }





}



// WEBPACK FOOTER //
// ./src/app/accounts/api-key/sub/notifier.component.ts